// extracted by mini-css-extract-plugin
module.exports = {"dark":"Meta-module--dark--3OTJW","meta__date":"Meta-module--meta__date--29eD7"};